import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment as env } from '../../environments/environment';
import { Product } from '../models/product.model';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductApiService implements OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  products: BehaviorSubject<Product[]> = new BehaviorSubject([]);
  $products: Product[] = [];
  loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loading$ = this.loading.pipe(distinctUntilChanged(), shareReplay(1));
  lastUpdate = 0;
  $refreshing: BehaviorSubject<boolean> = new BehaviorSubject(false);
  refreshing$ = this.$refreshing.pipe(distinctUntilChanged(), shareReplay(1));

  constructor(
    private http: HttpClient,
  ) { }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  fetch(terminalId: string) {
    this.loading.next(true);
    this.http.get<Product[]>(`${env.apiPath}/products/${terminalId}`)
      .toPromise()
      .then(response => {
        this.$products = response.map((product: Product) => {
          // sort packages by number
          // product.packages = product.packages.sort((a, b) => parseInt(a.number, 10) - parseInt(b.number, 10));
          product.totalVolume = product.packages.reduce((volume, item) => volume += item && item.volume && item.volume.value || 1, 0);
          return product;
        });
        this.products.next(this.get());
        this.loading.next(false);
        this.fetchAndRefresh(terminalId);
      })
      .catch(error => {
        console.error('ProductAPI: GET /products', error);
        this.products.next(this.get());
        this.loading.next(false);
        this.fetchAndRefresh(terminalId);
      });
  }

  fetchAndRefresh(terminalId: string) {
    this.$refreshing.next(true);
    this.http.get<Product[]>(`${env.apiPath}/products/${terminalId}/refresh`)
      .toPromise()
      .then(response => {
        this.$products = response.map((product: Product) => {
          // sort packages by number
          // product.packages = product.packages.sort((a, b) => parseInt(a.number, 10) - parseInt(b.number, 10));
          product.totalVolume = product.packages.reduce((volume, item) => volume += item && item.volume && item.volume.value || 1, 0);
          return product;
        });
        this.products.next(this.get());
        this.$refreshing.next(false);
      })
      .catch(error => {
        console.error('ProductAPI: GET /products', error);
        this.products.next(this.get());
        this.$refreshing.next(false);
      });
  }

  get() {
    return this.$products.map(product => {
      // need to recreate these objects to avoid deep references messing up things later
      const packages = product.packages.map(pack => Object.assign({}, pack));
      const p = Object.assign({}, product);
      p.packages = packages.sort((a, b) => parseInt(a.number, 10) - parseInt(b.number, 10));
      return p;
    });
  }

}
